// Auto-generated from Contentful - DO NOT EDIT
// Generated at: 2026-02-04T02:14:54.505Z

const hrcSupport = {
  id: `HRC`,
  text: `Your HR Coordinator is your direct link to personalized HR support, managing administrative tasks and swiftly addressing queries to streamline your HR experience. They ensure your HR needs are met promptly, embodying Bambee's commitment to efficient and tailored HR solutions.`,
  notes: `HR Coordinator`,
  list: [
    `General HR Guidance`,
    `Quick HR Resolutions`,
    `Policy Clarifications`,
    `Employee Escalations`,
    `HR Chat Support`,
    `Corrective Actions`,
  ],
} as const;

export default hrcSupport;
